import Vue from 'vue';
import VueMarkdownPlus from 'vue-markdown-plus';

Vue.use(VueMarkdownPlus);
